<template>
  <v-dialog v-model="dialog" max-width="1024">
    <template v-slot:activator="{ on }">
      <v-btn :color="error ? 'error' : 'primary'" dark v-on="on" outlined :small="small" :block="block">
        <template v-if="title">
          {{ title }}
        </template>
        <template v-else-if="selectedCatalog">
          {{ selectedCatalog.classCode }}
        </template>
        <template v-else>
          Выбрать
        </template>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        Выбор ИКПУ кода
      </v-card-title>
      <v-card-text class="py-1">
        <v-autocomplete v-model="catalog" :items="productCatalogs" :item-value="item => item" item-text="subPositionName" :dense="true" outlined :hide-details="true" @change="onChange" :filter="onFilterCatalog">
          <template v-slot:no-data>
            <v-list-item> По данному фильтру нет данных</v-list-item>
          </template>

          <template v-slot:item="{ item }">
            <h4>
              {{ item.classCode }}
              <br>
              <small>{{ item.name || item.subPositionName }}</small>
            </h4>
          </template>

          <template v-slot:selection="{ item }">
            <h4> {{ item.classCode }} {{ item.name || item.subPositionName }} </h4>
          </template>
        </v-autocomplete>
      </v-card-text>
      <template v-if="disablePackage">
        <v-card-title>
          Выбор пакета
        </v-card-title>
        <v-card-text class="py-1">
          <v-autocomplete v-model="catalogPackage" :items="catalog ? catalog.packageNames : []" :item-value="item => item" item-text="nameRu" :dense="true" outlined :disabled="!catalog" :clearable="true"
                          :filter="onFilterPackage">
            <template v-slot:no-data>
              <v-list-item> По данному фильтру нет данных</v-list-item>
            </template>

            <template v-slot:item="{ item }">
              <h4> {{ item.nameRu }} </h4>
            </template>

            <template v-slot:selection="{ item }">
              <h4> {{ item.nameRu }} </h4>
            </template>
          </v-autocomplete>
        </v-card-text>
      </template>
      <template v-if="this.catalog.lgotas"> 
        <v-card-title>
          Выбор льгота товара
        </v-card-title>
        <v-card-text class="py-1">
          <v-autocomplete v-model="lgota" :items="this.catalog.lgotas" :item-value="item => item.id" :item-text="item => item.id" :dense="true" outlined :hide-details="true">
            <template v-slot:no-data>
              <v-list-item> По данному фильтру нет данных</v-list-item>
            </template>
          </v-autocomplete>
        </v-card-text>
      </template>
      <v-card-text v-if="this.catalog.classCode" class="py-1">
        <v-alert
          v-if="this.catalog.lgotas"
          dense
          type="success"
        >
          Льгота для этого товара найдена.<br><b>Можете выбрать льготу!</b>
        </v-alert>
        <v-alert
          v-else
          dense
          type="info"
        >
          Льгота для этого товара не найдена.<br><b>Можете продолжать работу!</b>
        </v-alert>
      </v-card-text>
      <template>
        <v-card-actions>
          <v-btn color="secondary" text @click="dialog = false">
            Закрыть
          </v-btn>
          <v-spacer/>
          <v-btn color="primary" text @click="onSelectClicked" :disabled="$v.$invalid">
            Выбрать
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import {validationMixin} from "vuelidate"
import {required} from "vuelidate/lib/validators"
import _ from "underscore";

export default {
  name: "SelectInvoiceItemCatalog",
  mixins: [validationMixin],
  validations: {
    catalog: {
      required
    }
  },
  props: {
    productCatalogs: {
      type: Array,
      default() {
        return []
      }
    },
    selectedCatalog: {
      type: Object,
      default() {
        return null
      }
    },
    defaultCatalog: {
      type: String,
      default: null
    },
    defaultPackage: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    error: {
      type: Boolean,
      default: false
    },
    disablePackage: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: true
    },
    block: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dialog: false,
      lgota: null,
      catalog: {},
      lgotaPackage: [],
      catalogPackage: null
    }
  },
  methods: {
    async onChange() {
      this.resetDataLgota()
    },
    onSelectClicked() {
      this.$emit("selected", this.catalog, this.catalogPackage, this.lgota)
      this.dialog = false
    },
    selectFromDefaultValues() {
      if (this.defaultCatalog) {
        this.catalog = this.productCatalogs.find(pc => pc.classCode === this.defaultCatalog) || null
        if (this.catalog) {
          if (this.defaultPackage) {
            this.catalogPackage = this.catalog.packageNames.find(pn => pn.code === this.defaultPackage) || null
          }

          this.$emit("selected", this.catalog, this.catalogPackage)
        }
      }
    },
    resetDataLgota() {
      this.catalogPackage = null
      this.isLoadingLgota = true
      this.lgotaPackage = []
      this.hasLgota = false
      this.statusLgota = false
    },
    onFilterCatalog(item, search) {
      let name = item.name.toLocaleUpperCase()
      search = search.toLocaleUpperCase()
      let classCode = item.classCode
      let pieces = _.filter(search.split(' '), p => {
        return p.length > 0
      })
      return _.every(pieces, p => {
        return name.includes(p) || classCode.includes(p)
      })
    },
    onFilterPackage(item, search) {
      let pieces = _.filter(search.split(' '), p => {
        return p.length > 0;
      });
      return _.every(pieces, p => {
        return (item.nameRu.toString().toLocaleUpperCase().indexOf(p.toLocaleUpperCase()) !== -1) || item.code.toString().toLocaleUpperCase().indexOf(p.toLocaleUpperCase()) !== -1;
      });
    }
  },
  watch: {
    productCatalogs() {
      this.selectFromDefaultValues()
    },
    defaultCatalog() {
      this.selectFromDefaultValues()
    },
    defaultPackage() {
      this.selectFromDefaultValues()
    }
  },
  created() {
    this.selectFromDefaultValues()
  }
}
</script>

<style scoped>

</style>